import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Landmark, Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { fmtDate } from '../../lib/dates';

// Validated court trends that match this case's norms (or were run for it), with sample, period and court-level warning
export const MatterTrends = ({ matter }) => {
  const { api } = useAuth();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    if (data) return setData(null);
    setBusy(true);
    try { setData((await api.get(`/case-strategy/${matter.id}/trends`)).data); } catch { setData({ tendencias: [], nota: 'No se pudieron cargar' }); } finally { setBusy(false); }
  };
  return (
    <div className="mt-2">
      <button data-testid={`matter-trends-btn-${matter.id}`} onClick={toggle} className="flex items-center gap-1.5 rounded-full border border-amber-500/40 px-3 py-1 text-xs text-amber-200 hover:bg-amber-500/10">{busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Landmark className="h-3 w-3" />}Tendencias validadas</button>
      {data && (
        <div data-testid={`matter-trends-${matter.id}`} className="mt-2 flex flex-col gap-2 rounded-lg border border-slate-800 bg-slate-950/60 p-3 text-xs">
          <p className="text-slate-500">{data.nota}</p>
          {!data.tendencias.length && <p className="text-slate-400">No hay tendencias validadas que coincidan con las normas de esta causa. <Link to="/areas-y-tribunales" className="text-sky-300 underline">Analizar sentencias oficiales</Link></p>}
          {data.tendencias.map((t, i) => (
            <div key={i} data-testid="matter-trend-item" className="border-l-2 border-amber-500/50 pl-2">
              <p className="text-slate-200">{t.criterio}</p>
              <p className="text-slate-400">{t.tribunal} · {t.norma} · muestra {t.muestra}{t.periodo ? ` · ${t.periodo[0]}–${t.periodo[1]}` : ''} · analizado {fmtDate(t.analizado_at)} · validado por {t.validado_por}</p>
              <p className={t.coincide.includes('OTRO') ? 'text-rose-300' : 'text-emerald-300'}>{t.coincide}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
